import { Container, Grid } from "@mui/material";
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from "react";
import useResizeObserver from '@react-hook/resize-observer'

const getContainerStyles = (hasHeader, hasFooter) =>  {
	return {
		maxHeight: theme => `calc(100% - ${hasHeader ? theme.components.MuiToolbar.styleOverrides.root.height : '0px'} - ${hasFooter ? theme.AppFooter.height : '0px'})`,
		paddingBottom: theme => hasFooter && window.innerHeight < 500 ? theme.AppFooter.height : 0,
		minHeight: hasFooter ? '500px' : 'auto',
		overflowY: 'auto',
		maxWidth: '100vw !important'
	}
}

const BodyContainer = ({hasHeader, hasFooter, children}) => {
	const [styles, setStyles] = useState(getContainerStyles(hasHeader, hasFooter))

	const ref = useRef(null)
	useResizeObserver(ref, () => setStyles(getContainerStyles(hasHeader, hasFooter)))

	useEffect(() => {
		setStyles(getContainerStyles(hasHeader, hasFooter));
	}, [hasHeader, hasFooter])

	return (
		<Container sx={styles} ref={ref}>
			<Grid
				container
				columns={12}
				wrap="nowrap"
				height="100%"
				width="100%"
				direction="column"
				alignItems="center">

				{!hasHeader && <Grid item xs={1} width="100%" />}
				{children}
			</Grid>
		</Container>
	)
}

BodyContainer.propTypes = {
	hasHeader: PropTypes.bool,
	hasFooter: PropTypes.bool,
	children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired
}

export default BodyContainer;